import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetModifier from './CharacterSheetModifier.vue';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
import CharacterSheetExpansionFeatures from './CharacterSheetExpansionFeatures.vue';
import CharacterSheetCastingAddPower from './CharacterSheetCastingAddPower.vue';
import { groupBy, startCase, filter, cloneDeep } from 'lodash';
import CharacterSheetTicker from './CharacterSheetTicker.vue';
import CheckList from '@/components/CheckList.vue';
let CharacterSheetCasting = class CharacterSheetCasting extends Vue {
    constructor() {
        super(...arguments);
        this.groupBy = groupBy;
        this.startCase = startCase;
    }
    get alignments() {
        if (!this.forceCasting)
            return [];
        const hasLightPowers = this.forceCasting.powersKnown.some(power => power.forceAlignment === 'Light');
        const hasDarkPowers = this.forceCasting.powersKnown.some(power => power.forceAlignment === 'Dark');
        const hasUniversalPowers = this.forceCasting.powersKnown.some(power => power.forceAlignment === 'Universal') && ((hasLightPowers && hasDarkPowers) ||
            (!hasLightPowers && !hasDarkPowers) ||
            (hasLightPowers && !hasDarkPowers && this.forceCasting.universalSaveDC > this.forceCasting.lightSaveDC) ||
            (hasDarkPowers && !hasLightPowers && this.forceCasting.universalSaveDC > this.forceCasting.darkSaveDC));
        return filter([hasLightPowers && 'light', hasUniversalPowers && 'universal', hasDarkPowers && 'dark']);
    }
    isDisabled(level, casting) {
        const hasNotEnoughPoints = level >= casting.maxPoints - casting.pointsUsed;
        const isAlreadyCastAtHighLevel = this.highLevelCasting['level' + level];
        return hasNotEnoughPoints || isAlreadyCastAtHighLevel;
    }
    powerLevelText(level) {
        return level > 0 ? `Level ${level}` : 'At-will';
    }
    handleChangeTechPoints(techPointsUsed, highLevelCasting) {
        this.$emit('updateCharacter', { currentStats: { techPointsUsed, highLevelCasting } });
    }
    handleChangeForcePoints(forcePointsUsed, highLevelCasting) {
        this.$emit('updateCharacter', { currentStats: { forcePointsUsed, highLevelCasting } });
    }
    castTechPower(powerLevel) {
        const highLevelCasting = cloneDeep(this.highLevelCasting);
        if (parseInt(powerLevel) > 5) {
            highLevelCasting['level' + powerLevel] = true;
        }
        if (this.techCasting) {
            this.handleChangeTechPoints(Math.min(this.techCasting.maxPoints, this.techCasting.pointsUsed + parseInt(powerLevel) + 1), highLevelCasting);
        }
    }
    castForcePower(powerLevel) {
        const highLevelCasting = cloneDeep(this.highLevelCasting);
        if (parseInt(powerLevel) > 5) {
            highLevelCasting['level' + powerLevel] = true;
        }
        if (this.forceCasting) {
            this.handleChangeForcePoints(Math.min(this.forceCasting.maxPoints, this.forceCasting.pointsUsed + parseInt(powerLevel) + 1), highLevelCasting);
        }
    }
};
__decorate([
    Prop({ type: [Boolean, Object] })
], CharacterSheetCasting.prototype, "techCasting", void 0);
__decorate([
    Prop({ type: [Boolean, Object] })
], CharacterSheetCasting.prototype, "forceCasting", void 0);
__decorate([
    Prop(Object)
], CharacterSheetCasting.prototype, "highLevelCasting", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCasting.prototype, "customTechPowers", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCasting.prototype, "customForcePowers", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCasting.prototype, "allForcePowers", void 0);
__decorate([
    Prop(Object)
], CharacterSheetCasting.prototype, "settings", void 0);
__decorate([
    Prop(Object)
], CharacterSheetCasting.prototype, "tweaks", void 0);
CharacterSheetCasting = __decorate([
    Component({
        components: {
            CheckList,
            CharacterSheetModifier,
            CharacterSheetTweaker,
            CharacterSheetExpansionFeatures,
            CharacterSheetTicker,
            CharacterSheetCastingAddPower
        }
    })
], CharacterSheetCasting);
export default CharacterSheetCasting;
